<template>
  <div style="background-color: rgb(249, 249, 249);  width: 100%;">
    <div class="d-flex justify-center">
      <v-btn color="pink" small text class="d-flex justify-center" @click="handleGetMainHeight">
        <v-icon size="30" color="pink">mdi-chevron-down</v-icon>
      </v-btn>
    </div>
    <div class="pt-16 pb-16">
      <YA_ImitateContent1 />
    </div>
    <!-- <div class="pt-16 pb-16">
      <YA_Customers />
    </div> -->
  </div>
</template>

<script>
import YA_ImitateContent1 from '@/components/PowerImitate/YA_ImitateContent1.vue';

export default {
  name: 'PowerImitateContent',
  components: {
    YA_ImitateContent1,
  },
  data() {
    return {

    }
  },
  mounted() {

  },

  methods: {
    handleGetMainHeight() {
      this.$store.commit('HandlepowerImitateMainHeight', true);
    },
  }

};
</script>

<style scoped>

</style>